// extracted by mini-css-extract-plugin
module.exports = {"action":"ReportWithholdingSlipList__action--3U1LT","actionRight":"ReportWithholdingSlipList__actionRight--3xAnv"};